import { RouterProvider } from 'react-router-dom';
import { routes } from './Routes/Routes';
import './assets/css/menu.css';
import './assets/css/style.css';


function App() {
  return (
    <div className="dark_bg">
      {/* <Loader/> */}
      <RouterProvider router={routes} />
    </div>
  );
}

export default App;
